export default __webpack_public_path__ + "static/media/susie5.25dad6a4.jpg";